import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Screen1Component } from './landing-screen/screen1.component';
import { Screen2Component } from './screen2/screen2.component';
import { Home1Component } from './pages/home1/home1.component';
import { Home2Component } from './pages/home2/home2.component';
import { Home3Component } from './pages/home3/home3.component';
import { Home4Component } from './pages/home4/home4.component';
import { Home5Component } from './pages/home5/home5.component';
import { Home6Component } from './pages/home6/home6.component';
import { Home7Component } from './pages/home7/home7.component';
import { Home8Component } from './pages/home8/home8.component';
import { Home9Component } from './pages/home9/home9.component';
import { Home10Component } from './pages/home10/home10.component';
import { Home11Component } from './pages/home11/home11.component';
import { Home12Component } from './pages/home12/home12.component';
import { Home13Component } from './pages/home13/home13.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { ContactComponent } from './pages/contact/contact.component';


const routes: Routes = [
  {
    path:'',
    component:Home10Component
  },
  {
    path:'',
    component:Screen1Component
  },
  {
    path:'1',
    component:Screen2Component
  },
  {
    path:'home1',
    component:Home1Component
  },
  {
    path:'home2',
    component:Home2Component
  },
  {
    path:'home3',
    component:Home3Component
  },
  {
    path:'home4',
    component:Home4Component
  },
  {
    path:'home5',
    component:Home5Component
  },
  {
    path:'home6',
    component:Home6Component
  },
  {
    path:'home7',
    component:Home7Component
  },
  {
    path:'home8',
    component:Home8Component
  },
  {
    path:'home9',
    component:Home9Component
  },
  {
    path:'home10',
    component:Home10Component
  },
  {
    path:'home11',
    component:Home11Component
  },
  {
    path:'home12',
    component:Home12Component
  },
  {
    path:'home13',
    component:Home13Component
  },
  {
    path:'pricing',
    component:PricingComponent
  },
  {
    path:'contact',
    component:ContactComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
